import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';
import NavItem from '../NavItem';
// import { useOktaAuth } from '@okta/okta-react';
import { useMsal } from "@azure/msal-react";

const NavGroup = ({ item }) => {
  const { instance } = useMsal();
  const accounts = instance.getAllAccounts();
  // const { authState }  = useOktaAuth();
  const theme = useTheme();
  
  const items = item.children.map((menu) => {
    return <NavItem key={menu.id} item={menu} />;
  });

  return (
    <>
    {/* {!authState?.accessToken?.claims?.usergroups?.includes("ConfigToolAdmin") && item.title !== "Mapping"   && */}
    {/* {!accounts[0]?.idTokenClaims?.groups.includes("bc07e057-b44f-40df-ba4f-251acff402e8") && item.title !== "Mapping" && */}
      <List
        className="sideBarMenu"
        subheader={
          <Typography variant="caption" sx={{ ...theme.typography.menuCaption, color: '#8C8C8C' }} display="block" gutterBottom>
            {item.title}
          </Typography>
        }
      >
        {items}
        <Divider />
      </List>
    {/* } */}

    {/* {authState?.accessToken?.claims?.usergroups?.includes("ConfigToolAdmin")  && */}
    {/* { accounts[0]?.idTokenClaims?.groups.includes("bc07e057-b44f-40df-ba4f-251acff402e8") && */}
      {/* <List
        className="sideBarMenu"
        subheader={
          <Typography variant="caption" sx={{ ...theme.typography.menuCaption, color: '#8C8C8C' }} display="block" gutterBottom>
            {item.title}
          </Typography>
        }
      >
        {items}
        <Divider />
      </List> */}
    {/* } */}
    {/* } */}
    </>
  );
};

export default NavGroup;
